export default __webpack_public_path__ + "static/media/logo-login.eeb559cb.png";